import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import AuthLayout from '@/components/Layout/AuthLayout';
// import AuthLayout from '@/components/Layout/AuthLayout';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/PrimaryInput';
import { showToastNotification } from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';

import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';
interface IForgotResponse {
  status: boolean;
  message: string;
}

const VerfiyOtp: React.FC = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState<string[]>(['', '', '', '', '', '']);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const randomDeviceId = uuidv4();
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const location = useLocation();
  const [timer, setTimer] = useState<number>(59);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleOtpChange = (value: string, index: number) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move focus to next input if not last input
      if (value && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (e.key === 'Backspace' && otp[index] === '') {
      // Move to the previous input on Backspace
      if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handleSubmit = async () => {
    try {
      if (otp.some((digit) => digit === '')) {
        showToastNotification(
          'danger',
          'Please enter all 6 digits of the OTP.',
        );
        return;
      }
      setIsLoading(true);
      const deviceId =
        localStorage.getItem(import.meta.env.VITE_BUSINESS + 'deviceId') || '2025_' + randomDeviceId;
      localStorage.setItem(import.meta.env.VITE_BUSINESS + 'deviceId', deviceId);

      const fcmToken = localStorage.getItem(
        import.meta.env.VITE_BUSINESS + 'fcmToken',
      );
      const submitData = {
        ...(location?.state?.data?.email && {
          email: location?.state?.data?.email,
        }),
        otp: otp.join(''),
        deviceId: deviceId,
        deviceToken: fcmToken ? fcmToken : null,
      };
      const API = `${API_URL}${API_ENDPOINT?.forgetPassword}`;
      const response: IForgotResponse = await callApi(API, {
        method: 'POST',
        data: submitData,
      });
      if (response?.status === true) {
        showToastNotification('success', response?.message);
        navigate(RoutesLink?.newPassword, { state: { data: submitData } });
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setTimer(59);
      let deviceId = '';
      if (localStorage.getItem(import.meta.env.VITE_BUSINESS + 'deviceId')) {
        deviceId = localStorage.getItem(import.meta.env.VITE_BUSINESS + 'deviceId') ?? '';
      } else {
        deviceId = '2025_' + randomDeviceId;
      }
      localStorage.setItem(import.meta.env.VITE_BUSINESS + 'deviceId', deviceId);
      const fcmToken = localStorage.getItem(import.meta.env.VITE_BUSINESS + 'fcmToken');
      const submitData = {
        ...(location?.state?.data?.email && {
          email: location?.state?.data?.email,
        }),
        deviceId: deviceId,
        deviceToken: fcmToken ? fcmToken : null,
      };
      const API = `${API_URL}${API_ENDPOINT?.forgetPassword}`;
      const response: IForgotResponse = await callApi(API, {
        method: 'POST',
        data: submitData,
      });
      if (response?.status === true) {
        showToastNotification('success', response?.message);
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="d-flex justify-content-center align-items-center">
        <form
          className="text-center"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className="form-group mb-3">
            <label htmlFor="OTP" className="form-label fs-3 fw-medium">
              Enter OTP
            </label>
            <div className="otp-input justify-content-center d-flex gap-2">
              {otp.map((digit, index) => (
                <Input
                  key={index}
                  type="text"
                  className="form-control text-center rounded"
                  value={digit}
                  required
                  maxLength={1}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => {
                    inputRefs.current[index] = el;
                  }}
                />
              ))}
            </div>
          </div>
          <Button
            type="submit"
            disabled={isLoading}
            className="btn btn-primary py-2 px-4 mt-1 w-100 "
          >
            {isLoading ? <Spinner /> : 'Submit'}
          </Button>
          <div className="d-flex align-items-center justify-content-center mt-4">
            <Button
              type="button"
              className="btn btn-link text-decoration-none p-0 fw-medium text-primary fs-4"
              onClick={handleResendOtp}
              disabled={timer > 0}
            >
              Resend OTP{' '}
              {timer > 0 &&
                `(After 0:${timer.toString().padStart(2, '0')} sec)`}
            </Button>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default VerfiyOtp;
